import 'font-awesome-sass-loader';
import '../stylesheets/index.scss';
import Browser from '../shared/helpers/browser';
import BrickLayer from './brick-layer';

require('es6-promise').polyfill();

// If the parent page has queued elements, iterate
// over them and fire them.
if (window.BrickLayer && window.BrickLayer.q) {
  window.BrickLayer.q.forEach((args) => {
    BrickLayer.queue(...args);
  });
}

// Export BrickLayer to the window.
window.BrickLayer = BrickLayer;

const el = document.querySelector('.gwi-brick-app');
if (el) {
  BrickLayer.build(el, Browser.getQueryParams());
}



// WEBPACK FOOTER //
// ./src/client/index.jsx